export default __webpack_public_path__ + "static/media/pws_showcase_3.781bc5bf.png";